export interface ITTL {
  /**
   * Time To Live.
   */
  TTL: number;
}

/**
 * Checks whether a value is conformant to the ITTL interface.
 */
export const isITTL = (value: unknown): value is ITTL =>
  (value as ITTL).TTL !== undefined;
